package com.myrestaurants.sharedmodels

enum class Requirement {
    NotSpecified,
    Needed,
    NotNeeded,
    Recommended;

    val label: String
        get() = when(this) {
            NotSpecified -> "Not Specified"
            Needed      -> "Needed"
            NotNeeded   -> "Not Needed"
            Recommended -> "Recommended"
        }
}